module.exports = __webpack_public_path__ + "static/FloridaSunshineNewYork.48c8997b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/MotorCoachMaps/FloridaSunshineNewYork.jpg
// module id = 444
// module chunks = 61605834304381